import httpClient from 'API/httpClient';
import { Group, GroupBreadcrumbsResponse } from 'types/group';

const getCategoriesApi = async (): Promise<Group[]> => {
  const response = await httpClient.get('/groups');
  return response.data;
};

const getBreadcrumbsApi = async (
  groupId: number | string,
): Promise<GroupBreadcrumbsResponse> => {
  const response = await httpClient.get(`/group/${groupId}/breadcrumbs`);
  return response.data;
};

export { getCategoriesApi, getBreadcrumbsApi };
